import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { appendQueryParameters } from '@flowio/web-sdk';
import { CALLBACK_ORIGIN } from '../constants';

var getWindowSize = function getWindowSize() {
  if (typeof window.matchMedia === 'function') {
    var matchMedia600Width = window.matchMedia('(max-width: 600px)');
    return matchMedia600Width.matches ? 'fullscreen' : 'small';
  }

  return 'small';
};
/**
 * @description Used to inject library specific information, primarily the inline callback
 * URLs which will handle communication between the inline authorization flows and this lib.
 * This function must be used to enable Promise based responses from inline async autorization
 * calls (i.e. Fiserv 3DS)
 */


export default function withInlineActionConfiguration(authForm) {
  switch (authForm.discriminator) {
    case 'direct_authorization_form':
    case 'card_payment_source_authorization_form':
    case 'merchant_of_record_authorization_form':
      {
        var successUrl = appendQueryParameters("".concat(CALLBACK_ORIGIN, "/payment/callback/inline/success.html"), {
          flow_origin: window.location.origin
        });
        var failureUrl = appendQueryParameters("".concat(CALLBACK_ORIGIN, "/payment/callback/inline/failure.html"), {
          flow_origin: window.location.origin
        });
        return _objectSpread(_objectSpread({}, authForm), {}, {
          inline_action_configuration: {
            discriminator: 'browser_inline_action_configuration',
            inline_notification_urls: {
              success: successUrl,
              failure: failureUrl
            },
            action_configuration: {
              discriminator: 'card_browser_action_configuration',
              viewport: getWindowSize()
            }
          }
        });
      }

    default:
      return authForm;
  }
}
//# sourceMappingURL=with-inline-action-configuration.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/payment/lib/esm/utilities/with-inline-action-configuration.js
// module id = 605
// module chunks = 0 1